import { gql } from "@edreamsodigeo/frontend-api-client";

export const GET_PRIME_SITE_PROPERTIES_MY_TRIPS_REACTIVATION = gql`
  query PrimeSitePropertiesMyTripsReactivationQuery @ignore_update {
    primeSiteProperties {
      isPrimeMarket
    }
  }
`;
